export const isHTMLTagsPresent = (
	input: string,
	isSpecialCharValidation?: boolean | false
) => {
	return (
		input.match('<("[^"]*"|\'[^\']*\'|[^\'">])*>') != null || //NO SONAR
		(!isSpecialCharValidation && input.match('^[-a-zA-Z0-9_ ]*$') === null) //NO SONAR
	); //NO SONAR
};
const componentToHex = (c: any) => {
	var hex = c.toString(16);
	return hex.length === 1 ? '0' + hex : hex;
};

export const rgbToHex = (rgb: any, range: boolean = false) => {
	if (rgb.indexOf('rgb') > -1) {
		let value = rgb.substring(5).split(',');
		if (range && value.length === 4) {
			return `${parseInt(value[3].split(')')[0].trim()) * 100}`;
		} else {
			return (
				'#' +
				componentToHex(parseInt(value[0])) +
				componentToHex(parseInt(value[1])) +
				componentToHex(parseInt(value[2]))
			);
		}
	} else {
		return rgb;
	}
};
export const NumberFormattinginLocale = (number: number) => {
	return new Intl.NumberFormat().format(number);
};
export const loadState = (key: string) => {
	try {
		const serializeState = localStorage.getItem(key);
		if (!serializeState) return undefined;
		return JSON.parse(serializeState);
	} catch (error) {
		return undefined;
	}
};

export const saveState = (key: string, state: any) => {
	try {
		const serializeState = JSON.stringify(state);
		localStorage.setItem(key, serializeState);
	} catch (error) {
		// Ignore
	}
};

export const removeState = (key: string) => {
	try {
		localStorage.removeItem(key);
	} catch (error) {
		return undefined;
	}
};

export const removeAllState = () => {
	try {
		localStorage.clear();
		sessionStorage.clear();
	} catch (error) {
		return undefined;
	}
};

export const loadStateSession = (key: string) => {
	try {
		const serializeState = sessionStorage.getItem(key);
		if (!serializeState) return undefined;
		return JSON.parse(serializeState);
	} catch (error) {
		return undefined;
	}
};

export const saveStateSession = (key: string, state: any) => {
	try {
		const serializeState = JSON.stringify(state);
		sessionStorage.setItem(key, serializeState);
	} catch (error) {
		// Ignore
	}
};

export const removeStateSession = (key: string) => {
	try {
		sessionStorage.removeItem(key);
	} catch (error) {
		return undefined;
	}
};

export const getDiscount = (actualPrice: string, salePrice: string) => {
	const discountPercentage =
		((parseFloat(actualPrice) - parseFloat(salePrice)) /
			parseFloat(actualPrice)) *
		100;
	return Math.round(parseFloat(discountPercentage.toFixed(2)));
};

export const getCurrencySymbol = (currencyCode, locale = 'en-US') => {
	try {
		const currencyFormatter = new Intl.NumberFormat(locale, {
			style: 'currency',
			currency: currencyCode,
			useGrouping: true,
		});

		const currencySymbol = currencyFormatter
			.format(1)
			.replace(/\d|\.|,/g, '')
			.trim();
		return currencySymbol;
	} catch (error) {
		console.error('Error:', error);
		return '';
	}
};

//it will not ask the user anything instead gives the approximate location
export const getLocationByIP = async () => {
	try {
		const response = await fetch('https://ipapi.co/json/');
		const data = await response.json();
		const countryName = data.country_name;
		const countryCode = data.country_code;

		saveStateSession('FS-country', countryName);
		saveStateSession('FS-countryCode', countryCode);
	} catch (error) {
		saveStateSession('FS-country', `error fetching location:, ${error}`);
	}
};

export const getScreenSize = () => {
	return window.innerWidth;
};

export const capitalizeFirstLetter = (str) => {
	if (!str) return '';
	return str.charAt(0).toUpperCase() + str.slice(1);
};
